import React, { HTMLAttributeAnchorTarget } from 'react';

export interface IButtonWrapper {
  link?: string;
  target?: HTMLAttributeAnchorTarget;
  className?: string;
  children?: any;
}

const ButtonWrapper = ({ link, target = '_self', className, children }: IButtonWrapper) => {
  return link ? (
    <a href={link} target={target} className={className}>
      {children}
    </a>
  ) : (
    children
  );
};
export default ButtonWrapper;
